// removed by extract-text-webpack-plugin
module.exports = {"text":"qempo_Completed_text-2TRdCtg","line":"qempo_Completed_line-ZTAlSpB","button":"qempo_Completed_button-2o-RHwW","loading":"qempo_Completed_loading-2I8TqHG","paymentDoneImg":"qempo_Completed_paymentDoneImg-LaPyKHJ","title":"qempo_Completed_title-2O2Jysk","paymentDone":"qempo_Completed_paymentDone-14pq0i3","confirmation":"qempo_Completed_confirmation-SnQK19i"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Sale/completed/components/Completed.scss
// module id = 1832
// module chunks = 0